export default {
  path: "/definition-things",
  name: "DefinitionThings",
  component: () =>
    import(
      /* webpackChunkName: "about" */ "@/components/view/DefinitionThingsView"
    ),
  meta: {
    requiresAuth: true,
    roles: ["ADMIN"],
  },
  beforeEnter: (to, from, next) => {
    return next();
  },
};
